module.exports = __webpack_public_path__ + "static/media/moons_ortodoncia_invisible-1800.d3236ce2.jpg";